export default function initCursor() {
  const cursorElement = document.querySelector(".cursor");
  const root = document.documentElement;

  if (!cursorElement) {
    return;
  }

  document.body.classList.add('is-custom-cursor');

  function updateCursor(e) {
    const isButton = e.target.closest('a,button,.swiper-fade-next,.swiper-fade-prev');
    const isNextButton = e.target.closest('.swiper-cover-next');
    const isPrevButton = e.target.closest('.swiper-cover-prev');

    cursorElement.classList.toggle('is-hover', isButton);
    cursorElement.classList.toggle('is-prev', isPrevButton);
    cursorElement.classList.toggle('is-next', isNextButton);
    cursorElement.style.transform = `translate3d(${e.clientX}px,${e.clientY}px,0)`;
  }

  window.updateCursor = updateCursor;

  root.addEventListener(
    "mousemove",
    (e) => {
      updateCursor(e);
    },
    false
  );
  root.addEventListener(
    "drag",
    (e) => {
      updateCursor(e);
    },
    false
  );

}
